import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import { css } from "@emotion/react";

import { DiscountProgressBarContext } from "../context";

import { CompletedBreakpointBuilder } from "./Breakpoints/CompletedBreakpointBuilder";
import { LockedBreakpointBuilder } from "./Breakpoints/LockedBreakpointBuilder";
import { Tooltip } from "./Tooltip";

export const BreakpointRow = () => {
  const { theme, windowState, getWidgetConfig } = useContext(
    DiscountProgressBarContext
  );
  const [width, setWidth] = useState<number>(0);

  const breakpointRowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (breakpointRowRef.current) {
      setWidth(breakpointRowRef.current.clientWidth);
    }
  }, [
    breakpointRowRef,
    breakpointRowRef.current,
    breakpointRowRef.current?.clientWidth,
  ]);

  const [isHover, setIsHover] = useState<boolean[]>(() => {
    return windowState.discount.tiers.map(() => false);
  });

  const achievedTier = useMemo(() => {
    return windowState.progress.section;
  }, [windowState.progress.section]);

  const onMouseOver = (index: number) => {
    setIsHover((prev) => {
      const update = [...prev];
      update[index] = true;
      return update;
    });
  };

  const onMouseOut = (index: number) => {
    setIsHover((prev) => {
      const update = [...prev];
      update[index] = false;
      return update;
    });
  };

  // width: ${breakpointRowRef.current?.offsetWidth
  //   ? (1 / windowState.discount.tiers.length) *
  //     breakpointRowRef.current.offsetWidth
  //   : 100}px;

  const toolTipClass = css`
    position: absolute;
    justify-content: center;
    width: 120px;
    font-weight: bold;
    display: flex;
    z-index: 10;
    transform: translate(-50%, 10px);
    left: 50%;
  `;

  const breakpointRowClass = css`
    width: ${100}%;
  `;

  return (
    <div
      className={"ig-dp-breakpoint-row"}
      css={breakpointRowClass}
      ref={breakpointRowRef}
    >
      {windowState.discount.tiers.map((tier, index) => {
        if (!width) {
          return 0;
        }

        let left;
        if (windowState.discount.tiers.length === 1) {
          left = width - theme.breakpoint.size / 2;
        } else if (windowState.discount.tiers.length === 2) {
          if (index === 0) {
            left = width / 2 - theme.breakpoint.size / 2;
          } else {
            left = width - theme.breakpoint.size / 2;
          }
        } else {
          left =
            ((index + 1) / (windowState.discount.tiers.length + 1)) * width;

          if (index === 0) {
            left = left - theme.breakpoint.size;
          } else if (index !== windowState.discount.tiers.length - 1) {
            left = left - theme.breakpoint.size / 2;
          }
        }

        return (
          <span
            className={"ig-dp-breakpoint"}
            key={`tier-${tier.id}`}
            onMouseOver={() => onMouseOver(index)}
            onMouseOut={() => onMouseOut(index)}
            css={css`
              &:hover {
                cursor: pointer;
              }

              display: block;
              position: absolute;
              text-align: ${index === 0
                ? "left"
                : index === windowState.discount.tiers.length - 1
                  ? "right"
                  : "center"};
              left: ${left}px;
              top: ${theme.breakpoint.size / 2}px;
              width: ${theme.breakpoint.size}px;
              height: ${theme.breakpoint.size}px;
            `}
          >
            {achievedTier > index ? (
              <CompletedBreakpointBuilder
                key={`tier-breakpoint-${index}`}
                index={index}
              />
            ) : (
              <LockedBreakpointBuilder
                key={`tier-breakpoint-${index}`}
                index={index}
              />
            )}
            {isHover[index] ? (
              <span className={"ig-dp-tooltip"} css={toolTipClass}>
                <Tooltip tier={tier} />
              </span>
            ) : null}
          </span>
        );
      })}
    </div>
  );
};
